<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import { ref, onMounted } from 'vue'

const receiptTypes = ref([
{id: 'Thermal', name: 'Thermal'},
{id: 'Paper', name: 'Paper'}
  // Add more receipt types as needed
])

/*const receiptSizes = ref([
{id: '80mm', name: '80mm'},
    {id: '50mm', name: '50mm'},
    {id: 'A5', name: 'A5'},
    {id: 'A4', name: 'A4'}
  // Add more receipt sizes as needed
])*/
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import NumberInput from '../../../../components/ui/form/NumberInput.vue'
import GridInput from '../../../../components/ui/form/GridInput.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  endPoint: string,
  permissions?: Permission[],
  outlet?: any | null
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const title = 'POS Stations'

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
    id: props.data?.id || "",
    outlets_id: props.data?.outlets_id || props.outlet?.id || "",
    outlet: props.data?.outlet || props.outlet?.name || "",
    name: props.data?.name || "",
    pos_printer: props.data?.pos_printer || "",
    display_terminal: props.data?.display_terminal || "",
    balance_screen_secs: props.data?.balance_screen_secs || 10,
    touch_screen: props.data?.touch_screen || "",
    receipt_type: props.data?.receipt_type || "",
    recepit_size: props.data?.recepit_size || "",
    device_name: props.data?.device_name || "",
    active: props.data?.active || true,
    left_margin: props.data?.active || 0,
    right_margin: props.data?.active || 0,
    top_margin: props.data?.active || 0,
    button_margin: props.data?.active || 0,
    print_barcode: props.data?.print_barcode || true,
    font_size: props.data?.active || 10,
    font_bold: props.data?.active || false,
    uid: props.data?.uid || "",
  });

setFieldRules("outlets_id", [required("Outlet is required")]);
setFieldRules("name", [required("Name is required")]);
setFieldRules("pos_printer", [required("Printer is required")]);
setFieldRules("balance_screen_secs", [required("Balance Display Screen duration is required")]);
setFieldRules("receipt_type", [required("Receipt Type is required")]);
setFieldRules("recepit_size", [required("Receipt Size is required")]);

const handleSubmit = async (close: boolean, newRecord: boolean) => {
    console.log(formData.value)
    console.log(props.outlet)
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update-pos-station' : 'create-pos-station'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :tabList="[]" :formData="formData" @save="handleSubmit" :ignore-permission="true"
    @close="$emit('close')" width="35rem">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        
        <TextInput
          v-model="fields.outlet.value"
          label="Outlet"
          :readonly="true"
          :error="fields.outlets_id.touched ? fields.outlets_id.error : null"
          @blur="fields.outlets_id.touched = true"
        />

        <TextInput
          v-model="fields.name.value"
          label="Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />
        
        <TextInput
          v-model="fields.pos_printer.value"
          label="POS Printer"
          :readonly="isReadOnly"
          :error="fields.pos_printer.touched ? fields.pos_printer.error : null"
          @blur="fields.pos_printer.touched = true"
        />
        
        
        <TextInput
          v-model="fields.display_terminal.value"
          label="Display Terminal"
          :readonly="isReadOnly"
          :error="fields.display_terminal.touched ? fields.display_terminal.error : null"
          @blur="fields.display_terminal.touched = true"
        />
        
         
        <NumberInput
          v-model="fields.balance_screen_secs.value"
          label="Balance Screen Duration (seconds)"
          :readonly="isReadOnly"
          :error="fields.balance_screen_secs.touched ? fields.balance_screen_secs.error : null"
          @blur="fields.balance_screen_secs.touched = true"
        />
        
        <CheckInput
          v-model="fields.touch_screen.value"
          :readonly="isReadOnly"
          label="Touch Screen"
          :error="fields.touch_screen.touched ? fields.touch_screen.error : null"
          @blur="fields.touch_screen.touched = true"
        />
        
        <GridInput label="POS Printer Settings" class="col-span-2">
          <div class="grid md:grid-cols-2 gap-6">
            <TextInput
          v-model="fields.receipt_type.value"
          v-if="isReadOnly"
          label="Receipt Type"
          :readonly="isReadOnly"
          :error="fields.receipt_type.touched ? fields.receipt_type.error : null"
          @blur="fields.receipt_type.touched = true"
        />
          <SearchSelect
          v-model="fields.receipt_type.value"
          v-else
          label="Receipt Type"
          :options="receiptTypes"
          :remote="false"
          :readonly="isReadOnly"
          :error="
            fields.receipt_type.touched ? fields.receipt_type.error : null
          "
          @blur="fields.receipt_type.touched = true"
        />

        <TextInput
          v-model="fields.recepit_size.value"
          label="Receipt Size"
          placeholder="e.g., 80mm, A4"
          :readonly="isReadOnly"
          :error="fields.recepit_size.touched ? fields.recepit_size.error : null"
          @blur="fields.recepit_size.touched = true"
        />
        <!--<SearchSelect
          v-model="fields.recepit_size.value"
          v-else
          label="Receipt Size"
          :remote="false"
          :options="receiptSizes"
          :readonly="isReadOnly"
          :error="
            fields.recepit_size.touched ? fields.recepit_size.error : null
          "
          @blur="fields.recepit_size.touched = true"
        />-->
</div>
        </GridInput>

        <GridInput label="Receipt Settings" class="col-span-2">
          <div class="grid md:grid-cols-3 gap-6">
          <NumberInput
            v-model="fields.left_margin.value"
            label="Left Margin"
            :readonly="isReadOnly"
            :error="fields.left_margin.touched ? fields.left_margin.error : null"
            @blur="fields.left_margin.touched = true"
          />
          <NumberInput
            v-model="fields.right_margin.value"
            label="Right Margin"
            :readonly="isReadOnly"
            :error="fields.right_margin.touched ? fields.right_margin.error : null"
            @blur="fields.right_margin.touched = true"
          />
          <NumberInput
            v-model="fields.top_margin.value"
            label="Top Margin"
            :readonly="isReadOnly"
            :error="fields.top_margin.touched ? fields.top_margin.error : null"
            @blur="fields.top_margin.touched = true"
          />
          <!--<NumberInput
            v-model="fields.balance_screen_secs.value"
            label="Bottom Margin"
            :readonly="isReadOnly"
            :error="fields.balance_screen_secs.touched ? fields.balance_screen_secs.error : null"
            @blur="fields.balance_screen_secs.touched = true"
          />-->
          <NumberInput
            v-model="fields.font_size.value"
            label="Font Size"
            :readonly="isReadOnly"
            :error="fields.font_size.touched ? fields.font_size.error : null"
            @blur="fields.font_size.touched = true"
          />

          <CheckInput
          v-model="fields.font_bold.value"
          :readonly="isReadOnly"
          label="Font Bold"
          :error="fields.font_bold.touched ? fields.font_bold.error : null"
          @blur="fields.font_bold.touched = true"
        />
        <CheckInput
          v-model="fields.print_barcode.value"
          :readonly="isReadOnly"
          label="Print Barcode"
          :error="fields.print_barcode.touched ? fields.print_barcode.error : null"
          @blur="fields.print_barcode.touched = true"
        />
        </div>
        </GridInput>
        
    <TextInput
          v-model="fields.device_name.value"
          label="Device Name"
          :readonly="isReadOnly"
          v-if="mode == 'view'"
          :error="fields.device_name.touched ? fields.device_name.error : null"
          @blur="fields.device_name.touched = true"
        />
        
        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>